module.exports = __webpack_public_path__ + "a1bb5089a73c48a36c175d866d3af9e4.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/collosal_battles-872.webp
// module id = 221
// module chunks = 0